__turbopack_context__.v({
  "className": "noto_sans_17598f62-module__UTm79G__className",
});
